
exports.onClientEntry = async () => {
  if (typeof URLSearchParams === `undefined`) {
    // eslint-disable-next-line global-require
    require(`url-search-params-polyfill`);
  }
};
